const ftpAccounts = {
  ftp_accounts: [
    {
      user: 'cg-33e1333be07cb1d3',
      homedir: '/home2/ifwxzemy',
      type: 'sub',
      account: 'cg-33e1333be07cb1d3@ifw.xze.mybluehost.me',
      domain: 'ifw.xze.mybluehost.me',
    },
  ],
  server_name: 'ifw.xze.mybluehost.me',
  special_ftp_accounts: [
    {
      user: 'ifwxzemy',
      homedir: '/home2/ifwxzemy',
      type: 'main',
      account: 'ifwxzemy',
    },
    {
      user: 'ifwxzemy_logs',
      homedir: '/etc/apache2/logs/domlogs/ifwxzemy',
      type: 'logaccess',
      account: 'ifwxzemy_logs',
    },
    {
      user: 'ftp',
      homedir: '/home2/ifwxzemy/public_ftp',
      type: 'anonymous',
      account: 'ftp',
    },
    {
      user: 'anonymous',
      homedir: '/home2/ifwxzemy/public_ftp',
      type: 'anonymous',
      account: 'anonymous',
    },
  ],
};

export default ftpAccounts;
